import {escapeHtml} from '@malt/sanitize';

// only useful when used within another helper, since Handlebars automatically escape HTML everywhere
export default (text) => {
    return new Handlebars.SafeString(escapeHtml(text));
};

